import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import * as Util from '../../common/utilities';
import { lastXDays } from '../../common/utilities/dateRangeHelper';

import './Reports.scss';

import { BrandBand } from '../../common/components';
import { Header, McMenu, ReportList, ReportsFilter } from '../components/';

export class Reports extends Component {
  componentDidMount() {
    this.props.actions.getReports(lastXDays(7).dates);
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'reports.data.filter')) {
      this.props.actions.getReports(this.props.reports.data.filter);
    }
  }

  render() {
    const { filter, available } = this.props.reports.data;
    const { isLoading } = this.props.reports;

    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/analytics/reports"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <ReportsFilter actions={this.props.actions} filter={filter} />
          <ReportList
            actions={this.props.actions}
            filter={filter}
            reports={available}
            isLoading={isLoading}
            location={this.props.location}
          />
        </BrandBand>
      </McMenu>
    );
  }
}

Reports.contextTypes = {
  router: PropTypes.object
};

Reports.propTypes = {
  flags: PropTypes.object,
  reports: PropTypes.object.isRequired,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    flags: state.ecs.flags,
    reports: state.ecs.reports
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
